import { useEffect, useRef } from 'react';

export default function useMagnetic(strength = 0.35, labelStrength = 0.2) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const label = el.querySelector('.label');
    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      const x = e.clientX - (r.left + r.width / 2);
      const y = e.clientY - (r.top + r.height / 2);
      el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
      if (label) label.style.transform = `translate(${x * labelStrength}px, ${y * labelStrength}px)`;
    };
    const onLeave = () => {
      el.style.transition = 'transform .5s cubic-bezier(.16,1,.3,1)';
      el.style.transform = 'translate(0,0)';
      if (label) {
        label.style.transition = 'transform .5s cubic-bezier(.16,1,.3,1)';
        label.style.transform = 'translate(0,0)';
      }
      setTimeout(() => {
        el.style.transition = '';
        if (label) label.style.transition = '';
      }, 500);
    };
    el.addEventListener('mousemove', onMove);
    el.addEventListener('mouseleave', onLeave);
    return () => {
      el.removeEventListener('mousemove', onMove);
      el.removeEventListener('mouseleave', onLeave);
    };
  }, [strength, labelStrength]);
  return ref;
}
